import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router,  NavigationExtras, ActivatedRoute } from '@angular/router';
import {Http} from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
/*import { DataService } from '../service/data.service';*/
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { AuthenticationService } from '../service/authentication.service';
import { timerComponent } from "../cheque-book-request/timerComponent";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import "simple-keyboard/build/css/index.css";
import Keyboard from 'simple-keyboard';  
import 'assets/keyboard.css';
import { SessionTimerComponent } from '../session-timer/session-timer.component';
import { CaptchaComponent } from 'angular-captcha';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
//import { JSEncrypt } from 'core-js';
// import { NzMessageService } from 'ng-zorro-antd';
import { publicKey } from './config';

declare var getHexAscii: any;
declare var JSEncrypt: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',

  styleUrls: ['./login.component.css']
  /*providers: [DataService]*/
})

export class LoginComponent implements OnInit {
  private textareaValue = 'sample text';
  plainText: string = ''; // Plaintext
	cypherText: string = ''; // Encrypted ciphertext

  
	$encrypt: any;
  show = false;
  isDisabled: boolean = false;
  @ViewChild('username') el: ElementRef;
  statuslogin: any;
  focusin = true;
  rForm: FormGroup;
  post: any;
  usernameAlert = 'Please fill username';
  passwordAlert = 'Please fill password';
  loginAlert: string;
  loginError = false;
  returnUrl: string;
  isLoad = false;
  // tslint:disable-next-line:no-inferrable-types
  username: string = '';
  password = '';
  isHaveTDAccount = '';
  isHaveLoanAccount = '';
  requesteddata: any;
  keyboard1:any;
  isError = false;
  // timeLeft1: number = 25;
  errorDescription = ' ';
  blankSpaceNotAllow ='';
  // timeLeft1: number = 25;
  // errorDescription = ' ';
  blankusername = '';
  blankPassword='';
  spaceinpassword = '';
  showKeyboard='no';
  splcharinUsername='';
  display=' ';
  keyData="";
  model: any;
  body2:any;
   keyboard:Keyboard;
    regsplchar=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
   showPwType:boolean;
  sign:string="eye-open";
  badloginMsg: string = 'Note: User Will Be Blocked For One Day After 3 Unsuccessful Attempts';
  isActive: boolean = false;
  isActive1: string = 'NoBadLogin';
  captchatNoblank: string;
  incorrectCaptcha: string;
  Errorflagcap: string;
  bankName: any;
  atmBranch: any;
  contactUsPage: any;
  captchaInput: any;
  captcha: any;
  noteMsgFlag: string='yes';
  decrypt: any;
  iframeerror:string='Not Allowed';
  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
 /*   private authenticationservice: DataService,*/
    public router: Router,
    private webService: CallBackEndService,
    private logoutCall: AuthenticationService,
    private timetStart : timerComponent,
   private timer: SessionTimerComponent,
    private spinnerService: Ng4LoadingSpinnerService,
    private http: HttpClient
    //private captchaComponent : CaptchaComponent ,
  
  ) {
    this.getJSON().subscribe(data => {
      this.bankName = data.bankName;
      this.atmBranch = data.atmBranch;
      this.contactUsPage = data.contactUsPage;
     });    

    
    this.rForm = fb.group({
      'username' : [null, Validators.required],
      'password' : [null, Validators.required],
      'captcha' : [null, Validators.required],
      'captchaInput' : [null, Validators.required],
      'check':[null]
	});
    this.showPwType=false;
    // sets the ping interval to 15 seconds

    let loginTab =sessionStorage.getItem('userLoggedInForOnePage');
    console.log('vall--------'+loginTab);
  }
  public getJSON(): Observable<any> {
    return this.http.get('assets/SampleUrl.json'); 
  }
  
  @ViewChild(CaptchaComponent) captchaComponent: CaptchaComponent;
  //@ViewChild(CaptchaComponent, { static: true }) captchaComponent: CaptchaComponent;
  ngOnInit() {
    //this.authenticationservice.logout();
   // this.captchaComponent.captchaEndpoint   = 'http://10.102.9.121:9099/simple-captcha-endpoint-path';
    //this.$encrypt = new JSEncrypt();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
    this.spinnerService.hide();
    this.getCaptcha();
    $(document).ready(function() {
      $('input').bind('copy paste cut',function(e) { 
      e.preventDefault(); //disable cut,copy,paste
      });
     });

     try {
      if (top.location.hostname != self.location.hostname) throw 1;
      } catch (e) {
            //  alert("Clickjacking is detected");
             window.location.href = "/error-msg.component.html";    
             //window.top.close();                
        //top.location = self.location;                
             
      }
  }

  /*startLoadingSpinner() {
   this.spinnerService.show();
   console.log('dddloader');
   setTimeout(function() {
     this.spinnerService.hide();
   }.bind(this), 4000);
 }*/






logout(){
  alert('Impl Logout func.');
}
validateCaptcha()
{
  let captcha=this.rForm.controls['captchaInput'].value; // this.captchaInput; 
  let captchaWithoutSpaceNew = this.rForm.controls['captcha'].value.split(' ').join('');// this.captcha.split(' ').join('');
  //alert('cin,c2 : '+captcha+' '+captchaWithoutSpaceNew);
  if (captcha === '' ||captcha===' ' ||captcha===undefined||captcha===null) 
  {
   this.captchatNoblank = 'no';
    this.Errorflagcap="no";
    return false;
 }else if(captcha!==captchaWithoutSpaceNew)
   {
    this.incorrectCaptcha='no';
     this.Errorflagcap="no";
     return false;
  }
 else{
   this.captchatNoblank = '';
   this.incorrectCaptcha='';
    this.Errorflagcap="yes";
    return true;
  }
 }
clearCaptcha()
{
  this.captchatNoblank='';
  this.incorrectCaptcha='';
}

  addPost(post) {

/*

    let keyboard = new Keyboard({
      onChange: input => onChange(input),
      onKeyPress: button => onKeyPress(button)
    });



    function onChange(input) {

      document.querySelector(".input").value = input;


      console.log("Input changed", input);
    }

    function onKeyPress(button) {
      console.log("Button pressed", button);


      if (button === "{shift}" || button === "{lock}") handleShift();
    }

    function handleShift() {
      let currentLayout = keyboard.options.layoutName;
      let shiftToggle = currentLayout === "default" ? "shift" : "default";

      keyboard.setOptions({
        layoutName: shiftToggle
      });

    }
*/

   // this.spinnerService.show();
   
   
    this.requesteddata = JSON.stringify(post);
    console.log('this.requesteddata isss ' + this.requesteddata);
    this.username = post['username'];
    this.password = post['password'];

    // this.password= JSON.stringify(password);
    console.log(this.username + 'user name' + 'passw ' + this.password);
    var regexpspace=/\s+/;
    if(this.username==='' || this.username === undefined || this.username===null)
    {
      //this.spinnerService.hide();
      this.blankusername='no';
      this.password = ' ';
      this.username = ' ';

    }
    else if(this.username.match(regexpspace))
    {
     // this.spinnerService.hide();
      this.blankSpaceNotAllow='no';
    }
    else if(this.password==='' || this.password === undefined || this.password===null)
    {
     // this.spinnerService.hide();
      this.blankPassword='no';

    }
    else if(this.password.match(regexpspace))
    {
     // this.spinnerService.hide();
      this.spaceinpassword='no';
    }
  //   else if (this.rForm.controls['captchaInput'].value === '' ||this.rForm.controls['captchaInput'].value===' ' ||this.rForm.controls['captchaInput'].value===undefined||this.rForm.controls['captchaInput'].value===null) 
  //   {
  //    this.captchatNoblank = 'no';
  //     this.Errorflagcap="no";
  //     console.log("Errorflagcap-2----------"+this.Errorflagcap);
  //  }else if(this.rForm.controls['captchaInput'].value!= this.rForm.controls['captcha'].value.split(' ').join(''))
  //    {
  //     this.incorrectCaptcha='no';
  //      this.Errorflagcap="no";
  //      console.log("Errorflagcap-3----------"+this.Errorflagcap);
  //   }

    // this.password= JSON.stringify(password);

    else {
      if(this.validateCaptcha()){
      this.spinnerService.show();
       this.isDisabled =true;
       
      if (this.username !== '' || this.password !== '') {
		const request: IbRequest = new IbRequest();
    const text = `${this.password}`.trim()+`${this.username}`.trim();
        let response: IbResponse = null;
        this.isLoad = true;
        // request.param1 = getHexAscii('', this.username + this.password);
        // request.param2 = this.username;
        // request.param3 = getHexAscii('', this.password);
        if((this.username.length>117) && (this.password.length>117))
        {
         alert('The encrypted text is too long，please re-enter');
        }
        else{
          console.log("Encryption")
          this.decrypt = new JSEncrypt();
          this.decrypt.setPublicKey('-----BEGIN PUBLIC KEY-----MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA6ZRevmsIHR3jSw+U3qpLjVYxJX03LGZ/a81hN66tL+s3HWwcskCgCQlO+PwawuZ7ke2WrlFgCjzyWyFWLdG6YbJmAX7Ih7ZvXgjtO6dPJK9w3vRGtnxEwMa+OtAwkeUCgg99ka3CCkEq7v4x/YbQ+ZheDF6+YPw5wI37M7tk7FBiDWFg/js2ihrFTNA7SiuWQMEjmDwHmLbJlaAc8b957K6LVstk5Kaqq0UwYDZ9BVfbxxuvMVLdPPGejzru2iAt3qRWXL/BiOW18tiNTuvGFJxs2RLEt0IxHDEH6HZQpEpRfWdwiKVeIJIRSq60SBYwYLL1EiHiXc2s4YLc91P5b04GtufjRhedH0iWT+o2481YPZJH5MaqlXgK8zodaAqJKDDRk3lDAuuztIngxYJTLQG7MteFyLGdElTFVLaUS/NhHch7XVn9Sf//BaoDl8DXYz7ER4iTKE2zb1yGGYiKRzZo2Up5b3gr6TdiQfgpOd/lfVARCHMzHamN56tdN4bEn8R3pGdjXhmWl6goomIy9eheKtPBneB7uUURVKUotFvTt+ZdyJHi5ZkhLAlaLGT8Yg24uPuOg0LSVlZReDssHLpmffgiWtB5pSEuzyyL3KvmCpvMrHcWQz4jUIOE7RlvUkxtsG2VP7px5O++zTbH5Q0f1GuIxPiDuY9tKi6J7/sCAwEAAQ==-----END PUBLIC KEY-----');
          //request.param1 = this.decrypt.encrypt(this.username);
          request.param1 = getHexAscii('', this.username + this.password);
          request.param2 = this.username;
          console.log(request.param1)
          request.param3 =this.decrypt.encrypt(this.password);
        //this.$encrypt.setPublicKey(publicKey);
        //request.param1 = btoa(this.$encrypt.encrypt(this.username));
        //request.param2 = this.username;
        //request.param3 =btoa(this.$encrypt.encrypt(this.password));
        }
        this.webService.getResponse(request, 'login').subscribe((data: IbResponse) => {
			 this.spinnerService.hide();
          this.isError = true;
          this.rForm.get("captchaInput").reset();
          
          response = data;
          console.log('new userby bank' + response.status);
          if (response !== null && response.status === 'New_USER') {
            //sessionStorage.setItem('oldUserName', this.username);
           sessionStorage.setItem('storedUserName', this.username);
           sessionStorage.setItem('oldpasss', this.password);

           sessionStorage.setItem('token', response.param2);
            this.router.navigate(['/new-user-by-bank']);
          } else if (response.status === 'S200') {
            
           // this.router.navigate([this.returnUrl]);
			  console.log('sucess---------');
           //sessionStorage.setItem('currentUser');
           sessionStorage.setItem('isPasswordExpire', response.param1);
           sessionStorage.setItem('token', response.param2);
           sessionStorage.setItem('custNo', response.param3);
           sessionStorage.setItem('accounts', response.param5);
           sessionStorage.setItem('lastlogindateTime', response.param4.split(" ")[0] + ' ' + response.param4.split(" ")[1]);
           sessionStorage.setItem('mobileno', response.param4.split(" ")[3] );
           sessionStorage.setItem('emailId', response.param4.split(" ")[4] );
           sessionStorage.setItem('financialTrYN', response.param4.split(" ")[5]);
           sessionStorage.setItem('NextpasschangeDate', response.param4.split(" ")[2]);
            console.log("mobile no "+sessionStorage.getItem('mobileno'));
            const accounts = response.param5;
            const scoAccounts = [];
            const tdAccounts = [];
            const loanAccounts = [];
            const scoAndLoanAccounts = [];
            if( !(response.param5===""||response.param5===null)){
            for (const [key, value] of Object.entries(accounts)) {
              if (value === '11' || value === '12' || value === '13' || value === '14') {
                scoAccounts.push(key);
                scoAndLoanAccounts.push(key);
              }
              if (value === '20') {
                tdAccounts.push(key);
              }
              if (value === '30') {
                loanAccounts.push(key);
                scoAndLoanAccounts.push(key);
              }
            }
            this.isHaveTDAccount = 'show';
            this.isHaveLoanAccount = 'show';
            if (tdAccounts.length === 0) {
              this.isHaveTDAccount = 'hide';
            }
            if (loanAccounts.length === 0) {
              this.isHaveLoanAccount = 'hide';
            }

           sessionStorage.setItem('scoAccounts', JSON.stringify(scoAccounts));
           sessionStorage.setItem('scoAndLoanAccounts', JSON.stringify(scoAndLoanAccounts));
           sessionStorage.setItem('tdAccounts', JSON.stringify(tdAccounts));
           sessionStorage.setItem('loanAccounts', JSON.stringify(loanAccounts));
           sessionStorage.setItem('linkedAccounts', JSON.stringify(response.param6));
           sessionStorage.setItem('transactions', JSON.stringify(response.param8));
           sessionStorage.setItem('tdDetails', JSON.stringify(response.param9));
           sessionStorage.setItem('storedUserName', this.username);
           sessionStorage.setItem('isHaveTDAccount', this.isHaveTDAccount);
           sessionStorage.setItem('isHaveLoanAccount', this.isHaveLoanAccount);
           sessionStorage.setItem('userLoggedInForOnePage', "yes");
            sessionStorage.setItem('userLoggedInForOnePage1', "yes11");
            

            //sessionStorage.setItem('timeLeftGlobal',JSON.stringify(this.timeLeft1));
            //this.headerComponent.startTimer();
          
            this.isLoad = false;
           // this.timetStart.startTimer();
		     	// this.startTimer();
		    	this.timer.startSessionTimer();
          this.router.navigate([this.returnUrl]); 
				  
}
            else
            {
             // this.spinnerService.hide();
              this.rForm.get("username").reset();
              this.rForm.get("password").reset();
              this.errorDescription = response.statusDescription;
            }
          } else if (response.status === 'S101') {
            //this.spinnerService.hide();
            alert('Malicious Request Detected');
            this.isLoad = false;

          }/*else if (response.status === 'INVALID_USERID_PASSWORD'){
            this.spinnerService.hide();
            this.password = " ";
            this.username = " ";
            this.clearUserName = null;
            this.clearPassword = null;
            this.isError = true;
          }*/
   else if (response !== null && response.status === 'CHANGE_PASS_DATE_EXPIRE') {
    this.getCaptcha();
    //sessionStorage.setItem('oldUserName', this.username);
           sessionStorage.setItem('storedUserName', this.username);
           sessionStorage.setItem('oldpasss', this.password);

           sessionStorage.setItem('token', response.param2);
            this.router.navigate(['/change-password-after-expire']);
          }
          else if(response.status==='INVALID_USERID_PASSWORD'){
            this.getCaptcha();
            // this.spinnerService.hide();
            this.rForm.get("username").reset();
            this.rForm.get("password").reset();
            this.errorDescription = response.statusDescription;
            this.badloginMsg = response.param1;
            this.isActive=true;
            this.isActive1='badLogin'
          } else if(response.status==='ACCOUNT_BLOCKED_ONE_DAY'){
            this.getCaptcha();
            //this.spinnerService.hide();
            this.rForm.get("username").reset();
            this.rForm.get("password").reset();
            this.errorDescription = response.statusDescription;
            this.badloginMsg = response.param1;
            this.isActive=true;
            this.isActive1='badLogin'
          }
          else {
            this.getCaptcha();
            // this.spinnerService.hide();
            this.isError = true;
            this.isDisabled = false;
           

            // tslint:disable-next-line:no-unused-expression
            response.statusDescription;
            this.rForm.get("username").reset();
            this.rForm.get("password").reset();
            this.errorDescription = response.statusDescription;
            if(this.errorDescription==null || this.errorDescription==undefined || this.errorDescription===''){
              this.errorDescription=response.param1;
              console.log('error from param1' + this.errorDescription);
            }
            console.log('error' + this.errorDescription);
            this.isLoad = false;
           

          }

        });
      }
    }
    }


  }


  checked(event){
  
if(event.target.checked){
  this.noteMsgFlag='';
   console.log("IFFF");
   //this.rForm.get("password").disable();
  this.keyboard= new Keyboard({
      onChange: input => this.onChange(input),
      onKeyPress: button =>this. onKeyPress(button)
	 });
	 this.keyboard.setOptions({
    layoutName: "default"
  });
    (document.querySelector('.simple-keyboard') as HTMLElement).style.display = 'block';
     }
  else{
    this.noteMsgFlag='yes';
    console.log("Else");
 //this.rForm.get("password").enable();
   (document.querySelector('.simple-keyboard') as HTMLElement).style.display = 'none';
   
  }

  }
   onChange(input) {
    // this.password= document.querySelector('.input') as HTMLElement;
      this.rForm.get("password").setValue(input);
    


      console.log("Input changed", input);
    }

     onKeyPress(button) {
      console.log("Button pressed", button);
      if (button === "{shift}" || button === "{lock}") { this.handleShift(event); }
    }

     handleShift(event) {
     /* let currentLayout = this.keyboard.options.layoutName;
      let shiftToggle = currentLayout === "default" ? "shift" : "default";
      console.log("Layoyt---"+shiftToggle+"____"+ this.keyboard.options.layoutName)
        this.keyboard.setOptions({
        layoutName: shiftToggle
      });  */
      let currentLayout = this.keyboard.options.layoutName;
  let shiftToggle = currentLayout === "default" ? "shift" : "default";

  /**
   * If phyisical keyboard's CapsLock is enabled
   */
  if (event && event.getModifierState("CapsLock")) {
    shiftToggle = "shift";
  }
 console.log("Layoyt---"+shiftToggle+"____"+ this.keyboard.options.layoutName)
  this.keyboard.setOptions({
    layoutName: shiftToggle
  });
 console.log("Layoyt---"+shiftToggle+"____"+ this.keyboard.options.layoutName)
    }



 
  reset() {
    this.isError = false;
  }

  goToLink1(){
    //  window.open('http://www.abhinavbank.com/branch.asp','_blank');
    window.open(this.atmBranch,'_blank');

    //window.location.href='#/Disclaimer';
  }
  goToLink2(){
    // window.open('https://www.maheshbankpune.in/contact-us.html','_blank');
    // window.open('http://www.abhinavbank.com/contact.asp','_blank'); 
    window.open(this.contactUsPage,'_blank'); 

  }

  openModal(){
this.display='block';
  }

  onCloseHandled(){


    this.display='none';


  }



  /* interval;
 timeLeft : any=sessionStorage.getItem('timeLeftGlobal');
   startTimer() {
     console.log('logout');
     this.interval = setInterval(() => {
       if(this.timeLeft > 0) {
         this.timeLeft--;
        sessionStorage.getItem('timeLeftGlobal');
         console.log('sdf'+this.timeLeft);
     if(this.timeLeft == 0)
     {
       console.log('uhh');
     this.logoutCall.logout();
     }
       }
     },1000)
   }*/

  clearUserName()
  {
    this.blankusername='';
    this.blankSpaceNotAllow='';
    this.isDisabled =false;
	this.splcharinUsername='';
	//this.isError=false;
	//this.errorDescription='';
  }
  validatePassword()
  {
     var regexpspace=/\s+/;
   if(this.rForm.get("password").value==='' || this.rForm.get("password").value=== undefined || this.rForm.get("password").value===null)
    {
     this.blankPassword='no';
    }
    else if(this.rForm.get("password").value.match(regexpspace))
    {
     this.spaceinpassword='no';
    }  



  }
  clearPassword()
  {
    this.blankPassword ='';
    this.spaceinpassword ='';
	this.isDisabled =false;
	//this.isError=false;
	//this.errorDescription='';
  }

 onKeydown(event)
 {
  console.log("On Key Down");
 if( (document.querySelector('#check') as HTMLInputElement).checked){
     console.log("On Key Down ifff");
      event.preventDefault();
     event. stopPropagation();
 }

}

 validateUserName()
  {
    console.log("validate");
  var regexpspace=/\s+/;
    if(this.rForm.get("username").value==='' || this.rForm.get("username").value === undefined ||this.rForm.get("username").value===null)
    {
      this.blankusername='no';
    }
    else if(this.rForm.get("username").value.match(regexpspace))
    {
       this.blankSpaceNotAllow='no';
    }else if(this.rForm.get("username").value.match(this.regsplchar))
    {
     this.splcharinUsername='no';
    }
  }
  togglePassword()
  {
	 
	 if(this.sign==="eye-open")
	 {
	    this.sign="eye-close"
	 }else
	 {
       this.sign="eye-open"
	 }
  }


  validateCaptcha1()
  {
    console.log("Errorflagcap-1----------"+this.Errorflagcap);
    let captcha=this.rForm.controls['captchaInput'];
    let captchaWithoutSpaceNew = this.rForm.controls['captcha'].value.split(' ').join('');
    if (captcha.value === '' ||captcha.value===' ' ||captcha.value===undefined||captcha.value===null) 
    {
     this.captchatNoblank = 'no';
      this.Errorflagcap="no";
      console.log("Errorflagcap-2----------"+this.Errorflagcap);
   }else if(captcha.value!==captchaWithoutSpaceNew)
     {
      this.incorrectCaptcha='no';
       this.Errorflagcap="no";
       console.log("Errorflagcap-3----------"+this.Errorflagcap);
    }
   
   else{
      this.Errorflagcap="yes";
      console.log("Errorflagcap--4---------"+this.Errorflagcap);
   }
  console.log("Errorflagcap-----------"+this.Errorflagcap);
  }
  // clearCaptcha()
  // {
  //   this.captchatNoblank='';
  //   this.incorrectCaptcha='';
  // }

  getCaptcha() {
    //$rootScope.counter = 180;
          var alpha = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
                                 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V',
                                 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h',
                                 'j', 'k', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
                                  'u', 'v', 'w', 'x', 'y', 'z');
          var i;
          for (i = 0; i < 6; i++) {
                 var a = alpha[Math.floor(Math.random() * alpha.length)];
                 var b = alpha[Math.floor(Math.random() * alpha.length)];
                  var c = alpha[Math.floor(Math.random() * alpha.length)];
                  var d = alpha[Math.floor(Math.random() * alpha.length)];
                 var e = alpha[Math.floor(Math.random() * alpha.length)];
                 var f = alpha[Math.floor(Math.random() * alpha.length)];
                  var g = alpha[Math.floor(Math.random() * alpha.length)];
           }
          var code = a + ' ' + b + ' ' + ' ' + c + ' ' + d + ' ' + e + ' ' + f
                    + ' ' + g;
                    let captcha1= this.rForm.controls['captcha'];
                   captcha1.setValue(code);
    }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/login/login.component.ts